module.exports = __webpack_public_path__ + "static/media/Redfin.ec4cface.svg";